import { cn } from '@/lib/utils'
import type { ComponentPropsWithoutRef } from 'react'

export const Blockquote = ({
  className,
  children,
  ...props
}: ComponentPropsWithoutRef<'blockquote'>) => (
  <blockquote
    {...props}
    className={cn('relative border-l border-border/50 pl-4 italic', className)}
  >
    {children}
  </blockquote>
)
